{
  "start": 3, "min": 1, "max": 10, "startFreePoints": 2, "pointsPerLevel": 1,
  "attributes": {
    "body":         { "name": "Grit",         "desc": "+10 max HP and +7% melee damage per point." },
    "reflexes":     { "name": "Snap",     "desc": "+2.5% move speed, -5% spread, +4% reload speed per point." },
    "technical":    { "name": "Wrench",    "desc": "-4% vehicle damage taken while you drive, +8% infrastructure-hack duration per point." },
    "intelligence": { "name": "Wire", "desc": "+1 max RAM, +10% Short Circuit damage, +5% RAM regen per point." },
    "cool":         { "name": "Ice",         "desc": "-4% police detection range and -0.5 s search countdown per point." }
  }
}
